import { render, staticRenderFns } from "./ProfilsList.vue?vue&type=template&id=6484c61d&scoped=true&"
import script from "./ProfilsList.vue?vue&type=script&lang=ts&"
export * from "./ProfilsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilsList.vue?vue&type=style&index=0&id=6484c61d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484c61d",
  null
  
)

export default component.exports